import styled, { css } from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const Title = styled.h1`
	font-size: 16px;
	font-family: 'Poppins', sans-serif;
	font-weight: bold;
	margin-bottom: 0;
	color: ${colors.dark};
`;

export const Text = styled.span`
	font-size: 12px;
	font-family: 'Poppins', sans-serif;
	color: ${colors.grey};
	display: block;
	margin-bottom: 13px;
`;

export const PieChartCaption = styled.div`
	@media screen and (min-width: ${ScreenSize.laptop + 1}px) {
		transform: translateY(30px);
	}
`;

export const PieChartArea = styled.div`
	width: 100%;
	height: 400px;
	position: relative;
	.recharts-tooltip-wrapper {
		z-index: 2;
	}
	@media screen and (max-width: ${ScreenSize.laptop}px) {
		height: 342px;
	}
`;

export const StyledTooltip = styled.div`
	background: ${colors.light};
	padding: 10px;
	box-shadow: 0px 3px 6px ${colors.grey};
	border-radius: 3px;
	.label {
		font: 9px Poppins;
	}
	.intro {
		font: 18px Poppins;
	}
`;

export const StyledTotalValue = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font: 24px Poppins;
	font-weight: 600;
	color: ${colors.dark};
`;

const poppins = css`
	font-family: 'Poppins', sans-serif;
	font-style: normal;
`;

const textTitleStyle = css`
	${poppins};
	font-size: 14px;
	line-height: 20px;
`;

export const ConversionTitle = styled.em`
	${textTitleStyle};
	margin-bottom: 13px;
	text-align: center;
	display: block;
`;
